import { useSelector } from 'react-redux';
import { Button, Modal, Text } from '@vinted/web-ui';
import FaqEntryUrl from 'components/FaqEntryUrl';
import useTranslate from 'hooks/useTranslate';
import { FaqEntryType } from 'constants/faq-entry';
import { getUserId } from 'state/session/selectors';
import { blockUser, unblockUser } from 'data/api';
import { jsx as _jsx } from "react/jsx-runtime";

const UserBlockModal = _ref => {
  let {
    userId,
    username,
    isUserBlocked,
    isVisible,
    onCancel,
    onConfirm
  } = _ref;
  const translationKey = isUserBlocked ? 'unblock_modal' : 'block_modal';
  const translate = useTranslate("user.".concat(translationKey));
  const currentUserId = useSelector(getUserId);

  const getLearnMoreLink = () => /*#__PURE__*/_jsx(FaqEntryUrl, {
    type: FaqEntryType.BlockingMember,
    render: url => /*#__PURE__*/_jsx("a", {
      href: url,
      target: "_blank",
      rel: "noreferrer",
      children: translate('learn_more_link')
    })
  });

  const handleToggleBlockClick = async () => {
    if (!currentUserId) return;
    const toggleFunction = isUserBlocked ? unblockUser : blockUser;
    await toggleFunction({
      currentUserId,
      blockedUserId: userId
    });
    onConfirm();
  };

  return /*#__PURE__*/_jsx(Modal, {
    show: isVisible,
    title: translate('title', {
      username
    }),
    body: /*#__PURE__*/_jsx(Text, {
      text: translate('body', {
        learn_more_link: getLearnMoreLink()
      }),
      html: true
    }),
    testId: "user-block-modal",
    actions: [{
      text: isUserBlocked ? translate('actions.unblock') : translate('actions.block'),
      callback: handleToggleBlockClick,
      style: Button.Styling.Filled,
      theme: isUserBlocked ? 'primary' : 'warning',
      testId: "user-block-modal--".concat(isUserBlocked ? 'unblock' : 'block')
    }, {
      text: translate('actions.cancel'),
      callback: onCancel,
      theme: isUserBlocked ? 'primary' : 'muted',
      style: Button.Styling.Flat,
      testId: 'user-block-modal--cancel'
    }]
  });
};

export default UserBlockModal;